<template>
    <div>
        <div class="row">
            <div class="col-md-12 mb-50">
                <label class="form-label">Referans Model</label>
                <v-select-list multiple :options="c_referenceModels" label="VehicleReferenceModelManuelName" v-model="referenceModel" placeholder="Referans Model"></v-select-list>
            </div>
            <div class="col-lg-4 col-md-12 mb-50">
                <label class="form-label">Proje Dönemi Toplam Mesafe (KM)</label>
                <input class="form-control" v-model="totalKm" placeholder="Proje Dönemi Toplam Mesafe (KM)"/> 
            </div>
            <div class="col-lg-4 col-md-6 mb-50">
                <label class="form-label">Proje Dönem Sayısı (Ay)</label>
                <select class="form-control" v-model="totalMonth">
                    <option v-for="i in 37" :key="i" :value="(i - 1)">{{i - 1}}</option>
                </select>
            </div>
            <div class="col-lg-4 col-md-6 mb-50"> 
                <label class="form-label">Çalışma Gün Sayısı (Gün)</label>
                <select class="form-control" v-model="totalDay">
                    <option v-for="i in 32" :key="i" :value="(i - 1)">{{i - 1}}</option>
                </select>
            </div>
            <div class="col-md-6 mb-50">
                <label class="form-label">Aylık Ortalama Mesafe (KM)</label>
                <input class="form-control" :value="avgMonthKm" disabled placeholder="Aylık Ortalama Mesafe (KM)"/> 
            </div>
            <div class="col-md-6 mb-50">
                <label class="form-label">Günlük Ortalama Mesafe (KM)</label>
                <input class="form-control" :value="avgDayKm" disabled placeholder="Günlük Ortalama Mesafe (KM)"/> 
            </div>
            <div class="col-md-12 mb-1">
                <b-form-checkbox v-model="rememberReferenceModel" inline>Referans Modeli ve Değerleri Hatırla</b-form-checkbox>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12 mb-1">
                        <label class="form-label">Başlangıç İli</label>
                        <v-select-list v-model="startProvince" :options="provinces" label="Name" v-on:input="getDistricts(true)" placeholder="Başlangıç İli"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Başlangıç İlçesi</label>
                        <v-select-list :disabled="!startProvince" v-model="startDistrict" :options="startDistricts" label="Name" placeholder="Başlangıç İlçesi"></v-select-list>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12 mb-1">
                        <label class="form-label">Varış İli</label>
                        <v-select-list v-model="endProvince" :options="provinces" label="Name" v-on:input="getDistricts(false)" placeholder="Varış İli"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Varış İlçesi</label>
                        <v-select-list :disabled="!endProvince" v-model="endDistrict" :options="endDistricts" label="Name" placeholder="Varış İlçesi"></v-select-list>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <button :disabled="c_disabledCalculate" v-on:click="calculateDistance" class="btn btn-success btn-block">Ekle</button>
            </div>
        </div>
    </div>
</template>

<script>
import CalculatePriceApi from '@/api/calculate-price'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import {BFormCheckbox} from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
import randomatic from 'randomatic'
const currencyMask = createNumberMask({
    prefix: '',
    suffix: '',
    allowDecimal: true,
    includeThousandsSeparator: true,
    decimalSymbol:',',
    thousandsSeparatorSymbol:'.',
    allowNegative: false,
});
export default {
    props:{
        value:Object,
        oneDayKm:Number
    },
    components:{
        BFormCheckbox
    },
    data(){
        return{
            referenceModels: [],
            referenceModel: [],
            totalKm:null,
            totalMonth:0,
            totalDay:26,
            currencyMask,
            rememberReferenceModel:false,
            provinces:[],
            startProvince:null,
            endProvince:null,
            startDistricts:[],
            endDistricts:[],
            startDistrict:null,
            endDistrict:null,
        }
    },
    watch:{
        startProvince(){
            this.startDistrict = null
        },
        endProvince(){
            this.endDistrict = null
        },
    },
    mounted(){
        this.getReferenceModels()
        this.getProvince()
    },
    methods:{
        clearForm(){
            this.startProvince = null
            this.startDistrict = null
            this.endProvince = null
            this.endDistrict = null 
            if(!this.rememberReferenceModel){
                this.totalKm = null
                this.totalMonth = 0
                this.totalDay = 26 
                this.referenceModel = []
            }
        },
        calculateDistance(){
            this.referenceModel.forEach(rm => {
                this.value.UncalculatedRoutes.push({
                    id:randomatic("A0",10),
                    selected:false,
                    startProvince:this.startProvince,
                    startDistrict:this.startDistrict,
                    endProvince:this.endProvince,
                    endDistrict:this.endDistrict,
                    customerKm:0,
                    isAvoidTolls:false,
                    isAvoidHighways:false,
                    referenceModel:rm,
                    countOfTrips:1,
                    countOfDaysWorked:Math.ceil(this.avgDayKm/this.oneDayKm),
                    type:"Reservation",
                    calculatedDistance: this.avgDayKm
                })
            })
            this.clearForm()
        },
        getReferenceModels(){
            CalculatePriceApi.ReferenceModel.List()
            .then(res=>{
                this.referenceModels = res.data.Data
            })
        },
        getProvince(){
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241')
            .then((res) => {
                this.provinces = res.data.Data
            })
        },
        getDistricts(bool){
            if(this.startProvince?.Id || this.endProvince?.Id){
                let id = bool ? this.startProvince?.Id : this.endProvince?.Id
                if(id){
                    SystemDataApi.District(id)
                    .then((res) => {
                        if(bool) this.startDistricts = res.data.Data
                        else this.endDistricts = res.data.Data
                    })
                }
            }
        },
    },
    computed:{
        avgMonthKm(){
            if(this.totalKm && this.totalMonth){
                return Math.ceil(Number(this.totalKm) / Number(this.totalMonth))
            }else return 0
        },  
        avgDayKm(){
            if(this.avgMonthKm && this.totalDay){
                return Math.ceil(Number(this.avgMonthKm) / Number(this.totalDay))
            }else return 0
        },
        c_disabledCalculate(){
            if(this.referenceModel?.length > 0 && this.startProvince && this.endProvince && this.startDistrict && this.endDistrict && this.avgDayKm) return false
            else return true
        },
        c_referenceModels(){
            if(this.referenceModel.length > 0){
                const first = this.referenceModel[0]
                return this.referenceModels.filter(rm => rm.GroupNumber == first.GroupNumber)
            }else return this.referenceModels
        }
    }
}
</script>

<style>

</style>